module.exports = __webpack_public_path__ + "static/media/testPrototype_ie.cef34d85.png";